export function isAxisRange(range) {
  return Array.isArray(range) && range.length === 2 && (range[0] === null || typeof range[0] === 'number') && (range[1] === null || typeof range[1] === 'number');
}
export function assertAxisRange(range) {
  if (!isAxisRange(range)) {
    throw new Error("Expected axis range. Received: ".concat(range));
  }
}
export function isBoundedAxisRange(range) {
  return isAxisRange(range) && range[0] != null && range[1] != null;
}
export function assertBoundedAxisRange(range) {
  if (!isBoundedAxisRange(range)) {
    throw new Error("Expected bounded axis range. Received: ".concat(range));
  }
}
//# sourceMappingURL=GridAxisRange.js.map